import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FbLoginComponent } from './components/fb-login/fb-login.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [FbLoginComponent],
  exports: [FbLoginComponent],
})
export class FbLoginModule { }
